export default __webpack_public_path__ + "static/media/cart.e0e5936d.svg";